import React from "react";
import { Redirect } from "react-router-dom";
import { connect } from "react-redux";
// import { withRouter } from "react-router-dom";

// import FieldForceCard from "./components/FieldForceCard/FieldForceCard"
import "./index.scss";
import HierarchyManagementSection from "./components/HierarchyManagementSection/HierarchyManagementSection";
import Footer from "../Footer/Footer";
import { useNotification } from "../Notifications/NotificationProvider";

const HierarchyModule = ({ user_type }) => {
  const dispatchNotification = useNotification();

  if (
    user_type !== "bkash-super-user"
    // &&
    // user_type !== "territory_manager" &&
    // user_type !== "regional_manager" &&
    // user_type !== "area_manager" &&
    // user_type !== "cluster_head" &&
    // user_type !== "cs_super_user"
  ) {
    dispatchNotification({
      type: "ERROR",
      message: "You do not have access to Admin page",
    });
    // dispatchNotification({
    //   type: "ERROR",
    //   message: "Redirecting to main page",
    // });
    return <Redirect to="/signin" />;
  }

  return (
    <div className="main-container">
      <HierarchyManagementSection />
      <Footer />
    </div>
  );
};

const mapStateToProps = (state) => {
  let user_type = state.auth.authToken ? state.auth.authToken.type : null;

  return { user_type };
};

export default connect(mapStateToProps)(HierarchyModule);
